import type { EmptyReturnBoardItem } from '@chukua/common';
import { Alert, Button, DatePicker, Form, Modal } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';

interface MarkReturnedFormValues {
  returnedOn: Dayjs;
}

interface MarkReturnedModalProps {
  target: EmptyReturnBoardItem | null;
  error: string | null;
  submitting: boolean;
  onSubmit: (returnedOn: string) => Promise<void>;
  onCancel: () => void;
}

/** The day the empty went back to the depot, defaulting to today; a future day can't be picked, as the server would refuse it. */
export function MarkReturnedModal({ target, error, submitting, onSubmit, onCancel }: MarkReturnedModalProps) {
  return (
    <Modal open={target !== null} title={target ? `Mark ${target.containerNumber} returned` : ''} onCancel={onCancel} footer={null} destroyOnHidden>
      {error && <Alert className="mb-4" type="error" title={error} showIcon />}
      <Form<MarkReturnedFormValues>
        layout="vertical"
        requiredMark={false}
        initialValues={{ returnedOn: dayjs() }}
        onFinish={(values) => onSubmit(values.returnedOn.format('YYYY-MM-DD'))}
        disabled={submitting}
      >
        <Form.Item name="returnedOn" label="Returned on" rules={[{ required: true, message: 'Pick the day it was returned' }]}>
          <DatePicker className="w-full" disabledDate={(day) => day.isAfter(dayjs(), 'day')} />
        </Form.Item>
        <Form.Item className="mb-0 flex justify-end">
          <Button type="primary" htmlType="submit" loading={submitting}>
            Mark returned
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
